"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepfunctionsInstrumentCommand = void 0;
const clipanion_1 = require("clipanion");
const plugin_1 = require("../../helpers/plugin");
const __1 = require("../..");
class StepfunctionsInstrumentCommand extends __1.BaseCommand {
    constructor() {
        super(...arguments);
        this.dryRun = clipanion_1.Option.Boolean('-d,--dry-run', false);
        this.environment = clipanion_1.Option.String('-e,--env');
        this.forwarderArn = clipanion_1.Option.String('--forwarder');
        this.service = clipanion_1.Option.String('--service');
        this.stepFunctionArns = clipanion_1.Option.Array('-s,--step-function');
        this.mergeStepFunctionAndLambdaTraces = clipanion_1.Option.Boolean('-mlt,--merge-lambda-traces,--merge-step-function-and-lambda-traces', false);
        this.propagateUpstreamTrace = clipanion_1.Option.Boolean('--propagate-upstream-trace', false);
        this.fips = clipanion_1.Option.Boolean('--fips', false);
        this.fipsIgnoreError = clipanion_1.Option.Boolean('--fips-ignore-error', false);
    }
    execute() {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, plugin_1.executePluginCommand)(this);
        });
    }
}
exports.StepfunctionsInstrumentCommand = StepfunctionsInstrumentCommand;
StepfunctionsInstrumentCommand.paths = [['stepfunctions', 'instrument']];
StepfunctionsInstrumentCommand.usage = clipanion_1.Command.Usage({
    category: 'Serverless',
    description: 'Subscribe Step Function log groups to a Datadog Forwarder.',
    details: '--step-function expects a Step Function ARN\n--forwarder expects a Lambda ARN',
    examples: [
        [
            'View and apply changes to subscribe a Step Function Log Group to a Datadog Forwarder',
            'datadog-ci stepfunctions instrument --step-function arn:aws:states:us-east-1:000000000000:stateMachine:ExampleStepFunction --forwarder arn:aws:lambda:us-east-1:000000000000:function:ExampleDatadogForwarder --env dev --service example-service',
        ],
        [
            'View changes to subscribe a Step Function Log Group to a Datadog Forwarder',
            'datadog-ci stepfunctions instrument --step-function arn:aws:states:us-east-1:000000000000:stateMachine:ExampleStepFunction --forwarder arn:aws:lambda:us-east-1:000000000000:function:ExampleDatadogForwarder --env dev --service example-service --dry-run',
        ],
        [
            'View and apply changes to subscribe multiple Step Function Log Groups to a Datadog Forwarder',
            'datadog-ci stepfunctions instrument --step-function arn:aws:states:us-east-1:000000000000:stateMachine:ExampleStepFunction1 --step-function arn:aws:states:us-east-1:000000000000:stateMachine:ExampleStepFunction2 --forwarder arn:aws:lambda:us-east-1:000000000000:function:ExampleDatadogForwarder --env dev --service example-service',
        ],
    ],
});
//# sourceMappingURL=instrument.js.map